'use client';

import { useSyncExternalStore, useCallback } from 'react';
function getIsWindows(): boolean {
  if (typeof navigator === 'undefined') return false;

  // Modern approach using userAgentData
  if ('userAgentData' in navigator && navigator.userAgentData) {
    return (navigator.userAgentData as {
      platform: string;
    }).platform === 'Windows';
  }
  // Fallback to navigator.platform
  return navigator.platform?.toLowerCase().includes('win') ?? false;
}
export function useIsWindows() {
  const subscribe = _temp2;
  const getSnapshot = _temp3;
  const getServerSnapshot = _temp4;
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
function _temp4() {
  return false;
}
function _temp3() {
  return getIsWindows();
}
function _temp2(_callback) {
  return _temp;
}
function _temp() {}